module.exports = {
	"ask": "Ask",
	"asking": "Asking",
	"auction": {
		"notJoinedAny": "You have not joined any auction!"
	},
	"auctionProgress": {
		"lotsCancelled": {
			"long": "Lots Cancelled",
			"short": "Cancelled"
		},
		"lotsSkipped": {
			"long": "Lots Skipped",
			"short": "Skipped"
		},
		"lotsSold": {
			"long": "Lots Sold",
			"short": "Sold"
		},
		"progressBarMessage": "Completed <doneLotsCount /> of <totalLotsCount /> $t(lot) (<doneLotsPercentage />)"
	},
	"auctionStatus": {
		"cancelled": "The auction was cancelled.",
		"over": "The auction is over.",
		"paused": "The auction has been paused.",
		"waiting": "The auction hasn't started yet."
	},
	"bid": "Bid",
	"bidCount": "Bid",
	"bidCount_plural": "Bids",
	"bidLimitExceededShort": "exceeds limit",
	"bidStatus": {
		"cancelled": "Cancelled",
		"closed": "Closed",
		"closing": "Closing",
		"notStarted": "Not Started",
		"ongoing": "Ongoing",
		"sold": "Sold"
	},
	"bidStatusLabel": "Bid Status",
	"bidType": {
		"bid": "online bid",
		"floorBid": "floor bid"
	},
	"bidTypeDemonstrate": {
		"bid": "an $t(widget-common::bidType.bid)",
		"floorBid": "a $t(widget-common::bidType.floorBid)"
	},
	"buyerType": {
		"onsite": "an onsite buyer",
		"online": "an online buyer"
	},
	"by": "by",
	"cancel": "Cancel",
	"closingProgress": {
		"once": "Once",
		"twice": "Twice"
	},
	"connection": {
		"attemptMessage": "This is attempt __attempt__ out of __retries__.",
		"awaiting": "Awaiting connection.",
		"connected": "Connected to server!",
		"connecting": "Connecting to server",
		"loadingMessage": "Loading auction information",
		"lost": "Lost connection from server.",
		"reconnected": "Reconnected to server!",
		"reconnectedMessage": "It took __timeTaken__ seconds to reconnect.",
		"reconnecting": "Reconnecting to server",
		"reconnectingMessage": "Reconnecting in __timeNextReconnection__ seconds.",
		"unknownError": "Unknown connection error."
	},
	"eventConsole": {
		"error": {
			"accessDenied": "You don't have sufficient permissions to execute that action.",
			"alreadyLeading": "You're already the leading bidder on this lot, you can't make a bid on it.",
			"bidInvalid": "You made an invalid bid, please try again!",
			"bidLimitExceeded": "You have exceeded your bid limit of __limit__ for a single lot.",
			"bidTooLow": "The bid you made was too low, please try again!",
			"purchaseLimitExceeded": "You have exceeded your purchase limit of __limit__ for a single auction."
		},
		"event": {
			"administratorMessage": "Message from administrator",
			"auctionCancelled": "The auction was cancelled. All lots that weren't sold were also cancelled.",
			"auctionLoaded": "The auction was loaded, which means it should begin shortly!",
			"auctionOver": "The auction is now over. Thank you for participating!",
			"auctionPaused": "The auction has been paused.",
			"auctionResumed": "The auction has been resumed!",
			"auctionStarted": "The auction is now underway!",
			"bidMade": "__bidType__ of <bidAmount /> was made.",
			"bidUndone": "The bid of <bidAmount /> was reverted.",
			"lotCancelled": "The lot was cancelled.",
			"lotChanged": "Loaded lot #<lotRank />: <lotName />.",
			"lotClosed": "Bidding is now closed for this lot.",
			"lotClosing": "Bidding is now closing for this lot, hurry up!",
			"lotOpened": "Bidding is now open for this lot!",
			"lotPrebidded": "There was one pre-bid of <bidAmount />.",
			"lotPrebidded_plural": "There were <preBidCount /> pre-bids and the current leading bid is <bidAmount />.",
			"lotReopened": "Bidding was reopened for this lot!",
			"lotSkippedOne": "Skipped lot #<lotRank />.",
			"lotSkippedTwo": "Skipped lots #<lotOneRank /> and #<lotTwoRank />.",
			"lotSkippedMany": "Skipped lots #<lotStartRank /> to #<lotEndRank />.",
			"lotSold": "The lot was sold for <amount /> to <winner />."
		}
	},
	"leadingBid": "Leading Bid",
	"liveBidCount": "Live Bid",
	"liveBidCount_plural": "Live Bids",
	"lot": "lot",
	"lot_plural": "lots",
	"lotCatalog": {
		"autoScrollButton": {
			"long": "Automatically scroll to the current lot when it changes",
			"short": "Auto-scroll on lot change"
		},
		"countdownTooltip": "In <lotCount /> $t(lot)",
		"heading": "Lot #__lotRank__",
		"lotStatus": {
			"cancelled": "Cancelled",
			"current": "Current",
			"skipped": "Skipped",
			"sold": "Sold",
			"upcoming": "Upcoming"
		}
	},
	"lotMessages": {
		"cancelled": "The lot was cancelled.",
		"sold": "The lot was sold."
	},
	"lotRank": "Lot #",
	"module": {
		"auction": "Auction",
		"catalog": "Catalog",
		"events": "Events",
		"increments": "Increments",
		"information": "Information",
		"lots": "Lots",
		"progress": "Progress",
		"videoStream": "Video Stream"
	},
	"noBid": "No bid",
	"noDescription": "No description.",
	"of": "of",
	"preBidCount": "Pre-Bid",
	"preBidCount_plural": "Pre-Bids",
	"previouslySkipped": "Previously Skipped",
	"quickFilter": "Quick Filter",
	"soldFor": "Sold for",
	"to": "to",
	"underApproval": "Under Approval",
	"unknown": "Unknown",
	"unknownError": "An unknown error occured.",
	"userMessages": {
		"leadingBidder": "You are already the leading bidder on this lot.",
		"viewOnly": "You are in view only mode. You cannot make bids in this mode.",
		"wonLot": "You won this lot!",
		"wonSpecificLot": "You won lot #__lotRank__!"
	}
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/en/widget-common.json5
// module id = 1964
// module chunks = 6